import { useGraphQLQuery } from '@betterment/graphql';

import { HomeProductBundlesDocument } from '../graphql/productBundles.generated';

export const useProductBundles = () => {
  const { data } = useGraphQLQuery(HomeProductBundlesDocument, {
    throwOnError: true,
  });

  if (!data) return { data };

  const inProgressBundle = data.productBundles.find(bundle => bundle.isInProgress) || null;

  return {
    data: {
      inProgressBundle,
      allBundles: data.productBundles,
    },
  };
};
